<template>
  <div id="ges-detail" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="row p-2 mx-auto">
        <header-v2 :title="'Sistema de vigilancia epidemiológico'" />
        <div class="row w-100 mt-5">
          <div class="col-md-12">
            <div style="display: flex; left: 15px; margin-bottom: 10px">
              <label class="mr-2 breadcrumb-link"
                ><button
                  class="mt-0 p-0 pb-1 d-flex align-items-center breadcrumb-link back"
                  style="
                    border: none;
                    background-color: transparent;
                    font-size: 16px;
                  "
                  @click.prevent="backGes"
                >
                  Volver al GES
                </button></label
              >
            </div>
            <div class="mb-5">
              <ProfileEmployee :employee="employee" :loading="loading" />
            </div>
            <div class="mb-5">
              <FormSectionFirst
                @changeFirstForm="changeFirstForm"
                :isBusy="isBusy"
                :isDetail="isDetail"
                :answerResults="answerResults"
              />
            </div>
            <div class="mb-5">
              <TabsComponent
                @saveQuestion="saveQuestion"
                @getAnswersIpt="getAnswersIpt"
                :isQuestionsFirst="isQuestionsFirst"
                :isBusy="isBusy"
                :isDetail="isDetail"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 3 MODAL PROCESO EXITOSO  -->
    <modal-success :messageModal="messageModal" />

    <!-- 4 MODAL PROCESO FALLIDO -->
    <modal-error :error="error" />
  </div>
</template>

<script>
import {
  saveQuestion,
  dowloanFileIpt,
} from "@/services/health-tracker/ges/service";
import ApiPermisos from "@/services/apiPermisos";
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import ProfileEmployee from "./components/formIpt/ProfileEmployee.vue";
import FormSectionFirst from "./components/formIpt/FormSectionFirst.vue";
import TabsComponent from "./components/formIpt/TabsComponent.vue";
import ModalSuccess from "./modals/ModalSuccess.vue";
import ModalError from "./modals/ModalError.vue";

export default {
  components: {
    HeaderV2: () => import("@/components/common/header/HeaderV2.vue"),
    MainBarMenuV2,
    HeadingUser,
    ProfileEmployee,
    FormSectionFirst,
    TabsComponent,
    ModalSuccess,
    ModalError,
  },
  data() {
    const me = this;
    return {
      id: me.$route.params.id,
      employeeId: me.$route.params.employee_id,
      gesId: me.$route.params.ges_id,
      type: this.$route.params.type,
      category: this.$route.params.category,
      isDetail: me.$route.params.is_detail ? true : false,
      employee: {},
      loading: true,
      isBusy: false,
      formData: {
        inspection_by: "",
        tool_list: "",
        material_list: "",
        observation: "",
        work_analysis_file: null,
        answers: [],
      },
      messageModal: "IPT guardado exitosamente",
      error: {
        message: "",
      },
      answerResults: null,
    };
  },
  computed: {
    isQuestionsFirst() {
      const me = this;
      return (
        me.formData.inspection_by !== "" &&
        me.formData.tool_list !== "" &&
        me.formData.material_list !== ""
      );
    },
  },
  methods: {
    async loadProfileEmployee() {
      const me = this;
      me.loading = true;
      try {
        const { data } = await ApiPermisos.getEmployeeInfo(me.employeeId);
        me.employee = data?.employee;
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = false;
      }
    },
    changeFirstForm(data) {
      const me = this;
      me.formData = { ...me.formData, ...data };
    },
    async saveQuestion(data) {
      const me = this;
      me.isBusy = true;
      me.formData = { ...me.formData, ...data };

      const formData = new FormData();
      formData.append("work_analysis_file", me.formData.work_analysis_file);

      const sendData = {
        inspection_by: me.formData.inspection_by,
        tool_list: me.formData.tool_list,
        material_list: me.formData.material_list,
        observation: me.formData.inspection_by,
        answers: me.formData.answers,
      };

      if (me.formData.observation !== "")
        sendData.observation = me.formData.observation;
      try {
        await saveQuestion(me.id, sendData);

        if (me.formData.work_analysis_file)
          await dowloanFileIpt(me.id, formData);
        me.$bvModal.show("modal-success");
        setTimeout(() => {
          me.backGes();
        }, 5000);
      } catch (error) {
        me.error.message = "Error al guardar Formulario";
        me.$bvModal.show("modal-fail");
      } finally {
        me.isBusy = false;
      }
    },
    getAnswersIpt(values) {
      const me = this;
      me.answerResults = {
        inspection_by: values.inspection_by,
        tool_list: values.tool_list,
        material_list: values.material_list,
      };
    },
    backGes() {
      const me = this;
      me.$router.push({ name: "detailSve", params: { id: me.gesId, category: me.category, type: me.type, ipt: '2' } });
    }
  },
  mounted() {
    const me = this;
    me.loadProfileEmployee();
  },
};
</script>

<style lang="scss">
.breadcrumb-link {
  color: #5d5fef;
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  margin-top: 0.125em;
}
.card-form-section {
  // background-color: white;
  border-radius: 8px;
  padding: 16px;
  // box-shadow: 0 0rem 0.5rem rgba(0, 0, 0, 0.175);
  border: 1px solid #cfd8dc;
}
</style>
